import React, { FC, ReactNode } from 'react'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import Box from '@mui/material/Box'
import { SxProps, Theme } from '@mui/material/styles'

type SortableWidgetProps = {
  id: string
  disabled: boolean
  children: ReactNode
  sx?: SxProps<Theme>
}

export const SortableWidget: FC<SortableWidgetProps> = ({ id, disabled, children, sx }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    disabled,
  })

  const transformStyle = transform ? CSS.Transform.toString(transform) : undefined

  return (
    <Box
      ref={setNodeRef}
      sx={{
        cursor: disabled ? 'default' : 'grab',
        borderRadius: (theme) => theme.spacing(0.5),
        border: (theme) =>
          isDragging ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
        ...sx,
      }}
      style={{
        transform: transformStyle,
        width: 'auto',
        height: 'auto',
        transition,
        zIndex: isDragging ? 1 : 'auto',
      }}
      {...(disabled ? {} : attributes)}
      {...(disabled ? {} : listeners)}
    >
      {children}
    </Box>
  )
}

export default SortableWidget
